/**
 * 功能权限码判断（与后端 permissions.code / info.permissions 对齐）
 */
import { useAuthStore } from "@shared/store/modules/auth";
import type { PermissionAction } from "@shared/types/user";

function listHasCode(list: string[] | undefined, code: string): boolean {
    if (!code) return true;
    const values = list || [];
    if (values.includes("*")) return true;
    return values.includes(code);
}

/**
 * 按钮显隐只看按钮层：开则显示，关则隐藏；子 API 不影响。
 * @param _apiGranted 保留参数，显隐不再使用
 */
export function showActionByApis(buttonGranted: boolean, _apiGranted: boolean[] = []): boolean {
    return buttonGranted;
}

function actionVisible(action: PermissionAction): boolean {
    return showActionByApis(action.granted);
}

/**
 * 按 user/info.actions 的按钮层 granted 决定是否显示。
 * 超管 permissions=* 全开；找不到对应 action 时回退 permissions。
 */
export function canShowAction(code: string): boolean {
    if (!code) return true;
    const auth = useAuthStore();
    if (listHasCode(auth.permissions, "*")) return true;
    const action = auth.actions?.find(item => item.code === code);
    if (action) return actionVisible(action);
    return listHasCode(auth.permissions, code);
}

/** 当前登录用户是否拥有指定权限码（按钮走 actions 的按钮层；含超管 *） */
export function hasPermission(code: string): boolean {
    return canShowAction(code);
}

/** 按钮是否已挂到角色（路由守卫用） */
export function hasButtonPermission(code: string): boolean {
    if (!code) return true;
    const auth = useAuthStore();
    if (listHasCode(auth.permissions, "*")) return true;
    if (auth.actions?.length) return auth.actions.some(item => item.code === code);
    return listHasCode(auth.buttonCodes, code) || listHasCode(auth.permissions, code);
}
